<div class="mat">

<header>
    <label class="close_button" (click)="close()">x</label>
</header>

<div class="row">
    <label class="catlabel col-sm-5">Tier :</label>
    <label class="text col-sm-5">{{tierCount}}</label>
</div>
<div class="row">
    <label class="catlabel col-sm-5">Round :</label>
    <label class="text col-sm-5">{{roundCount}}</label>
</div>

<div class="row">
    <label class="catlabel col-sm-5">Comments :</label>
</div>

<div>
    <textarea rows="5" cols="60" class="text" readonly style="background-color:rgb(235,235,228);">{{comments}} </textarea>
</div>

<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
</div>